import ReactJson, { type ReactJsonViewProps } from 'react-json-view';
import { useTheme } from '@mui/material';

/**
 * App-wide wrapper around react-json-view. react-json-view themes are static,
 * so the palette must be picked per render from the active MUI mode — the
 * library default ('rjv-default') is light-only and unreadable on dark
 * surfaces (GLX-1721). Pass an explicit `theme` prop to override.
 */
const JsonViewer = ({ theme, ...props }: ReactJsonViewProps) => {
  const muiTheme = useTheme();
  const isDark = muiTheme.palette.mode === 'dark';

  return <ReactJson theme={theme ?? (isDark ? 'monokai' : 'rjv-default')} {...props} />;
};

export default JsonViewer;
